var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jade-toast-hub", style: { zIndex: _vm.zIndex } },
    [
      _c(
        "transition-group",
        { attrs: { name: "list", tag: "div" } },
        _vm._l(_vm.toasts.getQueue(), function (toast, index) {
          return _c(
            "div",
            { key: `key-${index}`, staticClass: "jade-toast-hub__toast" },
            [
              _c(
                "div",
                { staticClass: "jade-toast-hub__toast-container" },
                [
                  _c("jade-toast", {
                    attrs: { text: toast.text, actionName: toast.actionName },
                    on: { handleClick: () => _vm.toasts.remove(index) },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "leading",
                          fn: function () {
                            return [
                              toast.loading
                                ? _c("jade-spinner", {
                                    attrs: {
                                      size: "large",
                                      color: "on-color-high",
                                    },
                                  })
                                : _c("jade-icon", {
                                    attrs: {
                                      color: "on-color-high",
                                      size: "large",
                                      use: toast.icon,
                                    },
                                  }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }